import { autocompletion } from '@codemirror/autocomplete';
import { getAutocompleteSuggestions, insertSuggestion } from '../../services/autocompleteService';

/**
 * DSL Autocompletion Extension for CodeMirror
 * Provides intelligent function suggestions based on DSL context
 */
export const dslAutocompletion = autocompletion({
  override: [
    (context) => {
      try {
        const { state, pos } = context;
        const input = state.doc.toString();
        
        // Get suggestions from our autocomplete service
        const suggestions = getAutocompleteSuggestions(input, pos, {
          includeConstants: true,
          includeCategories: true,
          maxSuggestions: 15
        });
        
        if (!suggestions || suggestions.length === 0) {
          return null;
        }
        
        // Find the word being typed
        const line = state.doc.lineAt(pos);
        const lineText = line.text;
        const linePos = pos - line.from;
        
        // Find word boundaries
        let wordStart = linePos;
        let wordEnd = linePos;
        
        // Move backwards to find start of word
        while (wordStart > 0 && /\w/.test(lineText[wordStart - 1])) {
          wordStart--;
        }
        
        // Move forwards to find end of word
        while (wordEnd < lineText.length && /\w/.test(lineText[wordEnd])) {
          wordEnd++;
        }
        
        const from = line.from + wordStart;
        const to = line.from + wordEnd;
        
        // Convert our suggestions to CodeMirror format
        const options = suggestions.map(suggestion => {
          if (!suggestion || typeof suggestion !== 'object') {
            return null;
          }
          
          const option = {
            label: suggestion.name || suggestion.label || '',
            type: suggestion.type || 'function',
            info: suggestion.description || '',
            detail: suggestion.signature || suggestion.detail || ''
          };
          
          // Add template insertion for functions
          if (suggestion.type === 'function' && suggestion.template) {
            option.apply = (view, completion, from, to) => {
              const template = suggestion.template;
              const parenIndex = template.indexOf('(');
              
              if (parenIndex !== -1) {
                // Insert function with parentheses
                view.dispatch({
                  changes: { from, to, insert: template },
                  selection: { anchor: from + parenIndex + 1 }
                });
              } else {
                // Insert simple text
                view.dispatch({
                  changes: { from, to, insert: template }
                });
              }
            };
          }
          
          return option;
        }).filter(option => option !== null && option.label);
        
        if (options.length === 0) {
          return null;
        }
        
        return {
          from,
          to,
          options,
          validFor: /^\w*$/
        };
        
      } catch (error) {
        console.warn('DSL autocompletion error:', error);
        return null;
      }
    }
  ],
  activateOnTyping: true,
  closeOnBlur: true,
  maxRenderedOptions: 15,
  defaultKeymap: true
});